import { useEffect } from 'react';
import { trackUTMParams, getStoredUTMParams } from '../utils/utmTracker';
import { hasAnalyticsConsent, subscribeToConsentChanges } from '../utils/consent';

/**
 * React hook to automatically track UTM parameters on component mount
 * @param {boolean} trackOnMount - Whether to track UTM params on mount (default: true)
 * @returns {Object} UTM tracking data and functions
 */
export const useUTMTracking = (trackOnMount = true) => {
  useEffect(() => {
    if (!trackOnMount) {
      return undefined;
    }

    const attemptTracking = () => {
      if (typeof window === 'undefined') return;
      const existingParams = getStoredUTMParams();
      if (!existingParams || window.location.search.includes('utm_')) {
        trackUTMParams();
      }
    };

    if (hasAnalyticsConsent()) {
      attemptTracking();
      return undefined;
    }

    const unsubscribe = subscribeToConsentChanges((status) => {
      if (status === 'accepted') {
        attemptTracking();
      }
    });

    return () => {
      unsubscribe();
    };
  }, [trackOnMount]);

  return {
    trackUTMParams,
    getStoredUTMParams,
    getAllUTMData: () => {
      const { getAllUTMData } = require('../utils/utmTracker');
      return getAllUTMData();
    }
  };
}; 
